import * as components from './components';

export default [
  {
    path: '/masters/complaint-codes',
    component: components.ComplaintCodeList,
    name: 'complaintCodeList',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/masters/complaintcodes/routes.js